/** @format */

export const CHIPS = [
  {
    label: 'Цифровой слепок кабинета',
    variant: 'outlined',
  },
  {
    label: 'Расход бюджета',
    variant: 'outlined',
  },
  {
    label: 'Рекламные показатели',
    variant: 'outlined',
  },
  {
    label: 'Запланированные KPI',
    variant: 'outlined',
  },
  {
    label: 'Рекомендации к улучшению',
    variant: 'outlined',
  },
  {
    label: 'Сенсоры по критичности',
    variant: 'outlined',
  },
] as const;
